<script setup lang="ts">
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import PageTitle from "@/components/settings/PageTitle.vue";
import Translator from "@/utils/common/Translator.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import {useMessagesStore} from "@/stores/ToastDataStore.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import DialogHandler, {CommonDialogAction} from "@/utils/forms/DialogHandler.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import {computed} from "vue";
import DTOFileAttachmentInfo = namaTypes.DTOFileAttachmentInfo;
import ChangePasswordRequest = namaTypes.ChangePasswordRequest;

const userInfoList = computed(() => [
  {id: 'code', value: LoginUtils.loginInfo?.userInfo?.code},
  {id: 'name1', value: LoginUtils.loginInfo?.userInfo?.name1},
  {id: 'name2', value: LoginUtils.loginInfo?.userInfo?.name2},
]);

async function updateUserImage(object: Record<string, any>, removeImage?: boolean) {
  let attachmentInfo: DTOFileAttachmentInfo = object.mainFile?.attachmentInfo ?? {};
  let changePasswordInfo: ChangePasswordRequest = {
    userIdToChangePasswordFor: LoginUtils.currentUserId(),
    imageName: attachmentInfo?.fileName,
    passwordMustBeChanged: false,
    removeImage: removeImage
  };
  let response = await NamaCommon.namaFetch(NamaURLS.Change_Password, {
    params: {userImageFileId: attachmentInfo?.fileId},
    data: changePasswordInfo
  });
  if (response && response.result && response.result.succeded) {
    useMessagesStore().showSuccessMessage()
    LoginUtils.userImageSrc.value = LoginUtils.getCurrentUserImageSrc();
  }
}

async function openUpdateImgDialog() {
  let saveBtn: CommonDialogAction = new CommonDialogAction('save', async (object: Record<string, any>) => {
    await updateUserImage(object);
  });
  let removeBtn: CommonDialogAction = new CommonDialogAction('removeImage', async () => {
    await updateUserImage({}, true);
  });
  let cancelBtn: CommonDialogAction = CommonDialogAction.createCancelDialogAction(() => {
  });
  let presenter: QuestionFieldsPresenter = new QuestionFieldsPresenter();
  await presenter.edit([NamaCommon.createQuestionField("mainFile", FieldType.Binary)], []);
  let dialogBox = new DialogHandler([saveBtn, removeBtn, cancelBtn], Translator.translateId("UpdateUserImage"), true);
  await dialogBox.createPresenter(presenter as WidgetsPresenter);
  await dialogBox.runDialogBox();
}
</script>

<template>
  <div>
    <PageTitle title="myProfile" icon="person"/>
    <div class="tw-w-full tw-justify-items-center">
      <q-card-section
        class="tw-w-[80%] tw-shrink tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-h-fit tw-flex-nowrap tw-overflow-y-auto !tw-max-h-[90%]">
        <div style="text-align: -webkit-center;"
             class="tw-place-self-center tw-mb-2 tw-w-[29%]  mobile:tw-min-w-[99%] quad:compact:tw-w-[29.5%] quad:ultra:tw-w-[29.5%] compact:tw-mb-0.5 ultra:tw-mb-0 compact:tw-w-[29.5%] ultra:tw-w-[29.5%] horizontal:tw-w-[30%] tw-h-full">
          <q-avatar size="130px">
            <div
              class="tw-opacity-0 hover:tw-opacity-70 hover:tw-bg-primary-light dark:hover:tw-bg-primary-dark tw-cursor-pointer tw-size-[40%] tw-rounded-full tw-absolute tw-content-center"
              @click.stop="openUpdateImgDialog">
              <NamaIcon default-icon="edit" class="tw-size-10 active-white "/>
            </div>
            <img v-if="LoginUtils.userImageSrc.value" :src="LoginUtils.userImageSrc.value" alt="user">
          </q-avatar>
        </div>
      </q-card-section>
      <q-card
        class="tw-py-4 tw-w-[50%] mobile:tw-w-[90%] tw-bg-transparent tw-text-namaFontColor-light dark:tw-text-namaFontColor-dark tw-rounded tw-justify-center">
        <q-card-section
          class="tw-flex tw-flex-col tw-w-full tw-text-lg tw-text-namaFontColor-darkGray dark:tw-text-namaFontColor-dark tw-font-normal tw-h-fit !tw-max-h-[90%]">
          <div v-for="info in userInfoList" class="tw-w-full tw-flex tw-flex-row tw-justify-center tw-h-10">
            <div class="tw-font-bold tw-w-[30%] mobile:tw-w-[40%] tw-text-start" v-text="Translator.translateId(info.id)"/>
            <q-separator vertical color="primary"/>
            <span class="tw-w-[70%] mobile:tw-w-[60%] tw-px-5 tw-text-start" v-text="info.value"/>
          </div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<style scoped>

</style>
